import React from 'react';
import { usePWAInstall } from '@/hooks/usePWAInstall';
import { Button } from '@/components/ui/button';
import { Download, X } from 'lucide-react';

const PWA_INSTALL_DISMISSED_KEY = 'mythkit_pwa_install_dismissed';

export function PWAInstallBanner() {
  const { canInstall, promptInstall, isInstalled } = usePWAInstall();
  const [dismissed, setDismissed] = React.useState(() => {
    if (typeof window === 'undefined') return true;
    return localStorage.getItem(PWA_INSTALL_DISMISSED_KEY) === '1';
  });

  if (!canInstall || isInstalled || dismissed) return null;

  const handleInstall = async () => {
    await promptInstall();
    setDismissed(true);
    localStorage.setItem(PWA_INSTALL_DISMISSED_KEY, '1');
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(PWA_INSTALL_DISMISSED_KEY, '1');
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-50 flex items-center gap-3 p-3 rounded-lg shadow-lg bg-forest-green text-white border border-forest-green/80">
      <Download className="w-5 h-5 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">Install Myth-Kit</p>
        <p className="text-xs opacity-90">Add to home screen for quick access</p>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <Button size="sm" variant="secondary" className="text-forest-green" onClick={handleInstall}>
          Install
        </Button>
        <button
          type="button"
          onClick={handleDismiss}
          className="p-1 rounded hover:bg-white/20"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
